"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _base = require("@atlaskit/icon/base");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ArrowLeftIcon = function ArrowLeftIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" role=\"presentation\"><path fill=\"#fff\" fill-opacity=\".01\" d=\"M0 0h24v24H0z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.207 5.793a1 1 0 010 1.414L8.414 11H18a1 1 0 110 2H8.414l3.793 3.793a1 1 0 11-1.415 1.414l-5.499-5.5A.997.997 0 015 12.028v-.057a.996.996 0 01.293-.678l5.499-5.5a1 1 0 011.415 0z\" fill=\"currentColor\"/></svg>"
  }, props));
};

ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var _default = ArrowLeftIcon;
exports.default = _default;